import React, { ChangeEvent, useState } from 'react';
import { usePropertyRoomDescriptionDetail } from '../../../contextsProperty/ContextProperties';
import LateralPanel from '../../../../muiComponents/LateralPanel';
import Icon from '../../../../muiComponents/Icon';
import TextInput from '../../../../muiComponents/TextInput/TextInput';
import Button from '../../../../muiComponents/Button';
import useTranslate from '../../../../customHooks/useTranslate';
import Flag from '../../components/Flag';
import Label from '../Label';
import { DESCRIPTION_DEATIL_INITIAL_STATE } from '../../../../utils/property/propertyUtils';
import DeletePopUp from '../DeletePopUp';
import Title from '../Title';

const RoomNewDescriptionPanel = () => {
    const translate = useTranslate();
    const {
        id,
        idLanguage,
        languageCode,
        language,
        descriptionContent,
        isOpenPanel,
        handleDescriptionDetailChange,
        handleRoomDescription,
    } = usePropertyRoomDescriptionDetail();
    const [error, setError] = useState('');
    const [isDeletePopUpVisible, setIsDeletePopUpVisible] = useState(false);

    const cancelPanel = () => {
        handleDescriptionDetailChange(DESCRIPTION_DEATIL_INITIAL_STATE);
    };

    const handleSave = (_action?: 'delete') => {
        if (!descriptionContent) {
            setError(translate('required'));
            return;
        }
        setError('');
        const action = _action ? _action : parseInt(id) < 0 ? 'add' : 'update';
        handleRoomDescription(action, {
            id,
            idLanguage,
            languageCode,
            language,
            descriptionContent,
        });
        cancelPanel();
    };

    return (
        <>
            <LateralPanel
                open={isOpenPanel}
                className='flex-column gap-20 properties-description__panel'
            >
                <header className='flex flex-between flex-align-center padding-inline50'>
                    <Title
                        text='add_description'
                        className='text-secondary-color'
                    />
                    <Icon
                        iconName='Close'
                        className='cursor-pointer'
                        onClick={cancelPanel}
                    />
                </header>
                <main className='flex-column gap-30 height100perc overflow-y-auto padding-inline50'>
                    <div className='flex-column gap-10'>
                        <div className='flex flex-between flex-align-baseline'>
                            <Label text='description2' translated />
                            <div className='flex flex-align-center gap-10'>
                                <Flag code={languageCode} text={language} />
                                <p>{language}</p>
                            </div>
                        </div>
                        <TextInput
                            multiline
                            rows={15}
                            value={descriptionContent}
                            handleChange={(
                                e: ChangeEvent<HTMLTextAreaElement>
                            ) =>
                                handleDescriptionDetailChange({
                                    descriptionContent: e.target.value,
                                    __isChanged: true,
                                })
                            }
                            error={!!error}
                            errorMessage={error}
                        />
                    </div>
                </main>
                <footer className='flex flex-between padding-inline50'>
                    <Button
                        variant='contained'
                        className={'delete-button'}
                        onClick={() => {
                            setIsDeletePopUpVisible(true);
                        }}
                    >
                        {translate('delete')}
                    </Button>
                    <div className='flex gap-20'>
                        <Button variant='outlined' onClick={cancelPanel}>
                            {translate('cancel')}
                        </Button>
                        <Button
                            variant='contained'
                            onClick={() => handleSave()}
                        >
                            {translate('save')}
                        </Button>
                    </div>
                </footer>
            </LateralPanel>
            {isDeletePopUpVisible && (
                <DeletePopUp
                    open={!!isDeletePopUpVisible}
                    onSave={() => {
                        handleSave('delete');
                        setIsDeletePopUpVisible(false);
                        cancelPanel();
                    }}
                    onCancel={() => {
                        setIsDeletePopUpVisible(false);
                        cancelPanel();
                    }}
                />
            )}
        </>
    );
};

export default RoomNewDescriptionPanel;
